import { useSession } from '../../auth/session';
import { useLive } from '../../lib/live';

// Lädt die Sitzung (Name, Firmen mit Status) live neu, egal auf welcher Seite der App der Mandant gerade ist.
// So erscheint eine freigegebene weitere Firma überall sofort (Übersicht, Belege, Firmenwahl), und ein von der Kanzlei
// geänderter Ansprechpartner-Name auch in Begrüßung und Kopfzeile.
// Aus, solange nur der Wartebildschirm zu sehen ist: Der zeigt die Freischaltung selbst an („Zur App“).
export function useSessionLive(enabled: boolean) {
  const { refresh } = useSession();
  useLive(enabled ? ['clients'] : null, () => void refresh().catch(() => {}));
}
